(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  class PromoSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this._track      = this.querySelector('.promo-slider__track');
      this._btnPrev    = this.querySelector('.promo-slider__arrow--prev');
      this._btnNext    = this.querySelector('.promo-slider__arrow--next');
      this._dots       = Array.from(this.querySelectorAll('.promo-slider__dot'));
      this._cards      = Array.from(this._track ? this._track.children : []);
      this._currentIdx = 0;
      this._timer      = null;

      if (!this._track) return;

      this._autoplay     = this.dataset.autoplay === 'true';
      this._autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 4000;

      this._bindDrag();
      this._bindArrows();
      this._bindDots();
      this._bindScrollSync();

      if (this._autoplay) this._startAutoplay();
    }

    disconnectedCallback() {
      this._stopAutoplay();
    }

    /* ── Helpers ── */
    _getCardWidth() {
      if (!this._cards[0]) return 0;
      const style = getComputedStyle(this._track);
      const gap   = parseFloat(style.gap || style.columnGap || '0');
      return this._cards[0].getBoundingClientRect().width + gap;
    }

    _scrollTo(idx) {
      const total = this._cards.length;
      this._currentIdx = Math.max(0, Math.min(idx, total - 1));
      const offset = this._currentIdx * this._getCardWidth();
      this._track.scrollTo({ left: offset, behavior: 'smooth' });
      this._updateDots();
      this._updateArrows();
    }

    _updateDots() {
      this._dots.forEach((dot, i) => {
        const active = i === this._currentIdx;
        dot.classList.toggle('promo-slider__dot--active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    _updateArrows() {
      if (!this._btnPrev || !this._btnNext) return;
      this._btnPrev.disabled = this._currentIdx === 0;
      this._btnNext.disabled = this._currentIdx >= this._cards.length - 1;
    }

    /* ── Arrow buttons ── */
    _bindArrows() {
      if (this._btnPrev) {
        this._btnPrev.addEventListener('click', () => {
          this._stopAutoplay();
          this._scrollTo(this._currentIdx - 1);
        });
      }
      if (this._btnNext) {
        this._btnNext.addEventListener('click', () => {
          this._stopAutoplay();
          this._scrollTo(this._currentIdx + 1);
        });
      }
    }

    /* ── Dot buttons ── */
    _bindDots() {
      this._dots.forEach(dot => {
        dot.addEventListener('click', () => {
          this._stopAutoplay();
          this._scrollTo(parseInt(dot.dataset.index, 10));
        });
      });
    }

    /* ── Sync dot + arrow state while track scrolls (e.g. swipe) ── */
    _bindScrollSync() {
      if (!this._track) return;
      let scrollTimeout;
      this._track.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const cardW = this._getCardWidth();
          if (cardW > 0) {
            const newIdx = Math.round(this._track.scrollLeft / cardW);
            if (newIdx !== this._currentIdx) {
              this._currentIdx = newIdx;
              this._updateDots();
              this._updateArrows();
            }
          }
        }, 80);
      }, { passive: true });
    }

    /* ── Drag (mouse) ── */
    _bindDrag() {
      if (!this._track) return;
      let startX = 0, startLeft = 0, dragging = false;

      const onMouseDown = (e) => {
        dragging = true;
        startX   = e.pageX;
        startLeft = this._track.scrollLeft;
        this._track.classList.add('is-dragging');
      };
      const onMouseMove = (e) => {
        if (!dragging) return;
        e.preventDefault();
        const delta = startX - e.pageX;
        this._track.scrollLeft = startLeft + delta;
      };
      const onMouseUp = () => {
        if (!dragging) return;
        dragging = false;
        this._track.classList.remove('is-dragging');
        const cardW = this._getCardWidth();
        if (cardW > 0) {
          const newIdx = Math.round(this._track.scrollLeft / cardW);
          this._scrollTo(newIdx);
        }
      };

      this._track.addEventListener('mousedown', onMouseDown);
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    }

    /* ── Autoplay ── */
    _startAutoplay() {
      this._timer = setInterval(() => {
        const next = this._currentIdx + 1 < this._cards.length
          ? this._currentIdx + 1
          : 0;
        this._scrollTo(next);
      }, this._autoplaySpeed);
    }

    _stopAutoplay() {
      if (this._timer) {
        clearInterval(this._timer);
        this._timer = null;
      }
    }
  }

  if (!customElements.get('promo-slider')) {
    // Wrap as a custom element so Shopify hydrates it correctly
    class PromoSliderWrapper extends PromoSlider {}
    customElements.define('promo-slider', PromoSliderWrapper);
  }

  // Fallback: directly init if not using custom element tag
  document.querySelectorAll('.promo-slider-section').forEach(el => {
    if (!el.dataset.psInit) {
      el.dataset.psInit = '1';
      const slider = new PromoSlider();
      // Manually attach methods by setting __proto__ — simpler: just re-run init
      Object.assign(el, {
        _track:         el.querySelector('.promo-slider__track'),
        _btnPrev:       el.querySelector('.promo-slider__arrow--prev'),
        _btnNext:       el.querySelector('.promo-slider__arrow--next'),
        _dots:          Array.from(el.querySelectorAll('.promo-slider__dot')),
        _cards:         [],
        _currentIdx:    0,
        _timer:         null,
        _autoplay:      el.dataset.autoplay === 'true',
        _autoplaySpeed: parseInt(el.dataset.autoplaySpeed, 10) || 4000,
      });

      const s = el;
      s._cards = Array.from(s._track ? s._track.children : []);

      PromoSlider.prototype._getCardWidth.call(s);

      // Re-use prototype methods via call/apply
      const proto = PromoSlider.prototype;
      ['_getCardWidth','_scrollTo','_updateDots','_updateArrows',
       '_bindArrows','_bindDots','_bindScrollSync','_bindDrag',
       '_startAutoplay','_stopAutoplay'].forEach(m => {
        s[m] = proto[m].bind(s);
      });

      s._bindDrag();
      s._bindArrows();
      s._bindDots();
      s._bindScrollSync();
      if (s._autoplay) s._startAutoplay();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
